var exports = {
  "e": "x127c5a35--a1ebb1--spinner-container",
};

module.exports = exports;
